'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitIsSavedSearchCheck = exports.getSavedSearchId = exports.getSaveSearchCheckState = exports.SAVE_SEARCH_CHECK_SUCCESS = exports.SAVE_SEARCH_CHECK_REQUEST = exports.SAVE_SEARCH_CHECK_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _user = require('../modules/user');

var _config = require('../modules/config');

var _ItemPageUtils = require('../../pages/Item/ItemPageUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SAVE_SEARCH_CHECK_FAIL = exports.SAVE_SEARCH_CHECK_FAIL = 'la/ui/saveSearchCheck/FAIL';
var SAVE_SEARCH_CHECK_REQUEST = exports.SAVE_SEARCH_CHECK_REQUEST = 'la/ui/saveSearchCheck/REQUEST';
var SAVE_SEARCH_CHECK_SUCCESS = exports.SAVE_SEARCH_CHECK_SUCCESS = 'la/ui/saveSearchCheck/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    isSavedSearch: false,
    savedSearchId: 0,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SAVE_SEARCH_CHECK_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                isSavedSearch: false,
                savedSearchId: 0,
                success: false
            });
        case SAVE_SEARCH_CHECK_REQUEST:
            return (0, _extends3.default)({}, state, {
                success: false
            });
        case SAVE_SEARCH_CHECK_SUCCESS:
            var savedSearchId = action.payload ? action.payload.savedSearchId : 0;
            var isSavedSearch = savedSearchId > 0;
            return (0, _extends3.default)({}, state, {
                isSavedSearch: isSavedSearch,
                savedSearchId: savedSearchId,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var getSaveSearchCheckState = exports.getSaveSearchCheckState = function getSaveSearchCheckState(state) {
    return state.ui.saveSearchCheck;
};

var getSavedSearchId = exports.getSavedSearchId = function getSavedSearchId(state) {
    return state.ui.saveSearchCheck.savedSearchId;
};

/* ACTION CREATORS */
var submitIsSavedSearchCheck = exports.submitIsSavedSearchCheck = function submitIsSavedSearchCheck(searchParams, itemPageFacets) {
    return function (dispatch, getState) {
        if (itemPageFacets) {
            searchParams = (0, _ItemPageUtils.getItemSavedSearchQuery)(itemPageFacets);

            if (!searchParams.category_id) {
                return new _promise2.default(function (resolve) {
                    resolve(dispatch({
                        type: SAVE_SEARCH_CHECK_SUCCESS
                    }));
                });
            }
        }
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            type: SAVE_SEARCH_CHECK_REQUEST
        });
        return _api.SaveSearch.postIsSavedSearch({ authToken: authToken, deployment: deployment, searchParams: searchParams }).then(function (response) {
            dispatch({
                payload: response,
                type: SAVE_SEARCH_CHECK_SUCCESS
            });
        }).catch(function () {
            dispatch({
                type: SAVE_SEARCH_CHECK_FAIL
            });
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/saveSearchCheck.js
// module id = nQXN
// module chunks = 57